module.exports = "../dist/img/product-card-35.0143.jpg";